
import { useState } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import RetreatHero from './components/RetreatHero';
import RetreatCard from './components/RetreatCard';
import RetreatFilters from './components/RetreatFilters';

export default function Retreats() {
  const [selectedType, setSelectedType] = useState('all');
  const [selectedDuration, setSelectedDuration] = useState('all');

  const retreats = [
    {
      id: 1,
      title: 'Mindful Forest Retreat',
      location: 'Redwood National Park',
      type: 'wellness',
      duration: '7 days',
      price: 2499,
      capacity: 12,
      rating: 4.9,
      reviews: 87,
      image: 'https://public.readdy.ai/ai/img_res/50a58fb024e22f37f63eb5fe4d6e9b40.jpg',
      features: ['Daily Meditation', 'Yoga Sessions', 'Nature Walks', 'Organic Meals', 'Digital Detox'],
      description: 'Reconnect with nature and yourself in this transformative wellness retreat among ancient redwoods.'
    },
    {
      id: 2,
      title: 'Adventure Base Camp',
      location: 'Moab, Utah',
      type: 'adventure',
      duration: '5 days',
      price: 1899,
      capacity: 16,
      rating: 4.8,
      reviews: 124,
      image: 'https://readdy.ai/api/search-image?query=adventure%20base%20camp%20in%20red%20rock%20desert%20landscape%20with%20luxury%20tents%2C%20outdoor%20gear%20stations%2C%20rock%20climbing%20equipment%2C%20mountain%20biking%20trails%2C%20dramatic%20Utah%20canyon%20backdrop%2C%20active%20outdoor%20lifestyle%20setting&width=400&height=300&seq=ret2&orientation=landscape',
      features: ['Rock Climbing', 'Mountain Biking', 'Canyoneering', 'Stargazing', 'Expert Guides'],
      description: 'Push your limits with world-class adventure activities in the stunning red rock country of Utah.'
    },
    {
      id: 3,
      title: 'Culinary Farm Retreat',
      location: 'Sonoma County',
      type: 'culinary',
      duration: '4 days',
      price: 1699,
      capacity: 10,
      rating: 4.9,
      reviews: 156,
      image: 'https://readdy.ai/api/search-image?query=farm-to-table%20culinary%20retreat%20with%20outdoor%20kitchen%20pavilion%2C%20organic%20vegetable%20gardens%2C%20wine%20vineyard%20views%2C%20chef%20instruction%20area%2C%20harvest%20baskets%2C%20rustic%20elegant%20dining%20setup%20in%20countryside%20setting&width=400&height=300&seq=ret3&orientation=landscape',
      features: ['Cooking Classes', 'Farm Tours', 'Wine Tasting', 'Harvest Experience', 'Chef Mentorship'],
      description: 'Master farm-to-table cuisine while staying at a working organic farm in wine country.'
    },
    {
      id: 4,
      title: 'Digital Detox Sanctuary',
      location: 'Olympic Peninsula',
      type: 'wellness',
      duration: '6 days',
      price: 2199,
      capacity: 8,
      rating: 4.7,
      reviews: 93,
      image: 'https://readdy.ai/api/search-image?query=peaceful%20digital%20detox%20retreat%20cabin%20by%20pristine%20lake%20surrounded%20by%20old%20growth%20forest%2C%20no%20technology%20visible%2C%20meditation%20spaces%2C%20reading%20nooks%2C%20natural%20materials%2C%20serene%20disconnected%20environment&width=400&height=300&seq=ret4&orientation=landscape',
      features: ['No Technology', 'Meditation', 'Journaling', 'Forest Bathing', 'Mindful Activities'],
      description: 'Disconnect from the digital world and reconnect with yourself in pristine wilderness.'
    },
    {
      id: 5,
      title: 'Photography Expedition',
      location: 'Yellowstone National Park',
      type: 'creative',
      duration: '8 days',
      price: 2899,
      capacity: 14,
      rating: 4.8,
      reviews: 78,
      image: 'https://readdy.ai/api/search-image?query=photography%20expedition%20camp%20in%20Yellowstone%20with%20professional%20camera%20equipment%2C%20wildlife%20observation%20blinds%2C%20golden%20hour%20lighting%2C%20geysers%20and%20hot%20springs%2C%20photographers%20capturing%20nature%2C%20educational%20outdoor%20workshop%20setting&width=400&height=300&seq=ret5&orientation=landscape',
      features: ['Pro Photography', 'Wildlife Tracking', 'Landscape Workshops', 'Equipment Provided', 'Expert Instruction'],
      description: 'Capture the raw beauty of Yellowstone with professional photographers as your guides.'
    },
    {
      id: 6,
      title: 'Couples Romantic Escape',
      location: 'Big Sur Coast',
      type: 'romantic',
      duration: '3 days',
      price: 1299,
      capacity: 6,
      rating: 4.9,
      reviews: 201,
      image: 'https://readdy.ai/api/search-image?query=romantic%20couples%20retreat%20overlooking%20dramatic%20Big%20Sur%20coastline%2C%20intimate%20luxury%20tents%20with%20ocean%20views%2C%20private%20hot%20tubs%2C%20candlelit%20dining%20areas%2C%20sunset%20colors%20over%20Pacific%20Ocean%2C%20sophisticated%20romantic%20atmosphere&width=400&height=300&seq=ret6&orientation=landscape',
      features: ['Couples Massage', 'Private Dining', 'Sunset Views', 'Hot Tub', 'Wine Service'],
      description: 'Rekindle romance with your partner in an intimate setting overlooking the Pacific Ocean.'
    }
  ];

  const filteredRetreats = retreats.filter(retreat => {
    const typeMatch = selectedType === 'all' || retreat.type === selectedType;
    const durationMatch = selectedDuration === 'all' || 
      (selectedDuration === 'short' && parseInt(retreat.duration) <= 4) ||
      (selectedDuration === 'medium' && parseInt(retreat.duration) >= 5 && parseInt(retreat.duration) <= 7) ||
      (selectedDuration === 'long' && parseInt(retreat.duration) >= 8);
    return typeMatch && durationMatch;
  });

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <main>
        <RetreatHero />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <RetreatFilters 
            selectedType={selectedType}
            setSelectedType={setSelectedType}
            selectedDuration={selectedDuration}
            setSelectedDuration={setSelectedDuration}
          />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
            {filteredRetreats.map((retreat) => (
              <RetreatCard key={retreat.id} retreat={retreat} />
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
